export const headlight = [1.9, 1.85, 1.7];
